import axios from 'axios'

const ViolationReportService = {
  async report (data) {
    return axios.post('shared/violations/report', data)
  },

  async myViolations (params = {}) {
    return axios.get('shared/violations/my-violations', { params })
  },

  async getEvidence (filename) {
    return axios.get(`shared/violations/evidence/${encodeURIComponent(filename)}`, {
      responseType: 'blob'
    })
  }
}

export default ViolationReportService
